<template lang="pug">
  v-menu.button-select-role(
    v-model="menuRole"
    close-on-click
    close-on-content-click
    offset-x
    bottom
    right)
    template(v-slot:activator="{ on }")
      v-btn(color="primary" v-on="on" small)
        span {{ currentRole }}
    v-list.button-select-role__list
      v-list-item(v-for="role, i in roles"  :key="'role'+i")
        v-list-item-title(@click="setRole(role)")
          span {{ role }}
</template>

<script>
  export default {
    name: "ButtonSelectRole",
    props: {
      roles: {
        type: Array,
        default: function(){
          return []
        }
      }
    },
    data: () => ({
      menuRole: false,
      currentRole: 'escoge role',
    }),
    methods: {
      setRole(role){
        this.currentRole = role;
        this.$store.commit('setUserRole', role);
      }
    }
  }
</script>

<style lang="sass">
.button-select-role
  &__list .v-list-item
    min-height: 32px
  &__list .v-list-item__title
    cursor: pointer
</style>